import styled from "styled-components";

export const LineBorder = styled.div`
  border: 1px solid ${(props) => (props.color ? props.color : "#e0e0e0")};
  margin: 0 !important;
  border-radius: 7px;
  padding: 3%;
`;
